import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customPlaceholder'
})
export class CustomPlaceholderPipe implements PipeTransform {

  transform(value: string): string {
    let str = '';
    if (value != null && value.length > 0) {
      if (value == 'About') {
        str = 'eg. About(default), Info, About Us';
      } else if (value == 'Content') {
        str = 'eg. Content(default), Documents, Files, Data';
      } else if (value == 'Sessions') {
        str = 'eg. Sessions(default), Lectures, Files';
      } else if (value == 'Speakers') {
        str = 'eg. Speakers(default), Artists, Lecturers, Hosts';
      } else if (value == 'VenueDetails') {
        str = 'eg. Time & Venue(default)';
      } else if (value == 'Polls') {
        str = 'eg. Polls(default)';
      } else if (value == 'QnA') {
        str = 'eg. QnA(default), FAQ';
      } else if (value == 'Sponsors') {
        str = 'eg. Sponsors(default), Partners, Associates';
      } else if (value == 'Feedback') {
        str = 'eg. Feedback(default), Review';
      } else if (value == 'Contact Us') {
        str = 'eg. Contact Us(default)';
      } else if (value == 'Exhibitors') {
        str = 'eg. Exhibitors(default), ....';
      } else if (value == 'Organizers') {
        str = 'eg. Organizers(default), Hosts';
      } else if (value == 'registration') {
        str = 'eg. Registration(default), Enroll';
      } else if (value == 'notifications') {
        str = 'eg. Notifications(default), Alerts';
      } else if (value == 'chatroom') {
        str = 'eg. Chatroom(default), Review';
      } else if (value == 'attendees') {
        str = 'eg. Attendees(default), Invites';
      } else if (value == 'aboutCity') {
        str = 'eg. About City(default), About Venue';
      } else if (value.toLowerCase() == 'streaming') {
        str = 'eg. Live Streaming';
      }
    }
    return str;
  }

}



// WEBPACK FOOTER //
// /app/src/app/core/pipes/custom-placeholder.pipe.ts